<template>
  <div :class="{ [brandClasses.inline]: inline }">
    <p class="text-sm" :class="{ [brandClasses.inlineText!]: inline && !!brandClasses.inlineText }">
      {{ message }}
      <span class="sr-only">Klarna</span>
      <vf-icon
        v-if="inline"
        class="align-baseline i-block"
        :height="imageHeight"
        :src="logos.klarna"
        :width="imageWidth"
      />
    </p>
    <vf-icon
      v-if="!inline"
      class="align-baseline i-block"
      :height="imageHeight"
      :src="logos.klarna"
      :width="imageWidth"
    />
    <base-button
      :aria-label="$t.help"
      class="min-h-6 min-w-6 items-center ws-nowrap body-4 underlined i-flex "
      :class="[
        !inline && 'ml-2',
        inline && brandClasses.inlineCta,
      ]"
      @click="DialogKlarna.keep().open({ currency, installmentPrice, isInThreshold })"
    >
      <vf-icon v-if="ctaVariant === 'icon'" name="help" />
      <span v-else>{{ $t.klarnaPayments.learnMore }}</span>
    </base-button>
    <p
      v-if="$t.klarnaPayments.disclaimerText"
      class="text-xs lh-3"
      :class="{ [brandClasses.inlineDisclaimer!]: inline && !!brandClasses.inlineDisclaimer }"
    >
      {{ $t.klarnaPayments.disclaimerText }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  currency: string
  inline?: boolean
  price: number
}>()

const { $formatPrice, $locale, $t } = useNuxtApp()
const { logos } = useAppConfig().assets.payment
const { DialogKlarna } = useDialogsStore()

// App configs used inside computed function leak memory
// This clones the config to break the reactivity and fix the leak
// A better solution is probably available by looking deeper into the app configs
const {
  brandClasses,
  ctaVariant,
  imageHeight,
  imageWidth,
  installments: installmentsConfig,
  maxThreshold,
  minThreshold
} = {
  ...useAppConfig().components?.klarna
}
const installments = installmentsConfig[$locale] || installmentsConfig.default

const installmentPrice = computed(() => {
  const installment = props.price / (installments)
  return Math.ceil(installment * 100) / 100
})

const isInThreshold = computed(() => props.price > minThreshold && props.price < maxThreshold)

const message = computed(() => replaceAll(
  isInThreshold.value ? $t.klarnaPayments.inThreshold : $t.klarnaPayments.belowThreshold,
  {
    amount: $formatPrice(installmentPrice.value, props.currency),
    max: $formatPrice(maxThreshold, props.currency),
    min: $formatPrice(minThreshold, props.currency),
    installments
  }
))
</script>
